import AddMore from './AddMore';

export const checkIsSummaryBox = ( stateProps, secOrIndIndex) => {
  const editableIndex = stateProps.editableIndex;
  let isSummaryBox = true;
  if (editableIndex === secOrIndIndex) {
    isSummaryBox = false;
  }
  return isSummaryBox;
};
export const getAddMore = (props) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  const jobSeekerData = formikProps.values.jobSeekerData;
  const sectionName = stateProps.sectionData.sectionName;

  if ((sectionName !== 'download'  && sectionName !== 'summarize') && (jobSeekerData.length > 0 || checkIsSummaryBox(stateProps, 0))) {
    const newPart = jobSeekerData[jobSeekerData.length - 1];
    return ( <AddMore props={props} newPart={newPart} />);
  } else {
    return null;
  }
};
